import { ReportPage, ReportTable } from '@/components';
import type { LocalGovernmentFundTableProps } from '@/features/mold/utils/pdf/pdf-components-props';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

export const LocalGovernmentFundTableBFormat: FC<
  LocalGovernmentFundTableProps
> = ({ fiscalYear, header, rowData, footer, dateByCreated, paperSize }) => {
  const { t } = useTranslation();

  return (
    <ReportPage
      title={{
        text: t('report-local-government-fund-table-B-title', {
          year: fiscalYear,
        }),
      }}
      layout={{ paperSize, orientation: 'landscape' }}
      pagePadding={10}
      caption={{
        unit: 'thousand',
      }}
      dateByCreated={dateByCreated}
    >
      <ReportTable
        header={header}
        data={rowData}
        footer={footer}
        tableWidth="100%"
        borderColor="secondary"
      />
    </ReportPage>
  );
};
